"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicCoursework = exports.getPublicCourseworks = exports.deleteCourseworkRelation = exports.postCourseworkRelation = exports.putCourseworkOrganization = exports.putCourseworkAccessibility = exports.deleteCourseworkPermission = exports.postCourseworkPermission = exports.putCourseworkAction = exports.delCoursework = exports.postCoursework = exports.putCoursework = exports.getCoursework = exports.getCourseworks = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var courseworksAuthorizedPath = root_1.lmsAuthorized + '/courseworks/';
var courseworksPublicPath = root_1.lmsPublic + '/courseworks/';

var getCourseworks = function getCourseworks(authentication, queryParameters) {
  return common_1.get(authentication, courseworksAuthorizedPath, queryParameters);
};

exports.getCourseworks = getCourseworks;

var getCoursework = function getCoursework(authentication, id) {
  return common_1.get(authentication, courseworksAuthorizedPath + id);
};

exports.getCoursework = getCoursework;

var putCoursework = function putCoursework(authentication, coursework) {
  return common_1.put(authentication, courseworksAuthorizedPath + coursework.id, coursework);
};

exports.putCoursework = putCoursework;

var postCoursework = function postCoursework(authentication, coursework) {
  return common_1.post(authentication, courseworksAuthorizedPath, coursework);
};

exports.postCoursework = postCoursework;

var delCoursework = function delCoursework(authentication, id) {
  return common_1.del(authentication, courseworksAuthorizedPath + id);
};

exports.delCoursework = delCoursework;

var putCourseworkAction = function putCourseworkAction(authentication, id, action, data) {
  return common_1.putSub(authentication, courseworksAuthorizedPath, id, action, data);
};

exports.putCourseworkAction = putCourseworkAction;

var postCourseworkPermission = function postCourseworkPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, courseworksAuthorizedPath, id, permission);
};

exports.postCourseworkPermission = postCourseworkPermission;

var deleteCourseworkPermission = function deleteCourseworkPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, courseworksAuthorizedPath, id, permissionId);
};

exports.deleteCourseworkPermission = deleteCourseworkPermission;

var putCourseworkAccessibility = function putCourseworkAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, courseworksAuthorizedPath, id, accessibility);
};

exports.putCourseworkAccessibility = putCourseworkAccessibility;

var putCourseworkOrganization = function putCourseworkOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, courseworksAuthorizedPath, id, organizationId);
};

exports.putCourseworkOrganization = putCourseworkOrganization;

var postCourseworkRelation = function postCourseworkRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, courseworksAuthorizedPath, id, relation);
};

exports.postCourseworkRelation = postCourseworkRelation;

var deleteCourseworkRelation = function deleteCourseworkRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, courseworksAuthorizedPath, id, relationId);
};

exports.deleteCourseworkRelation = deleteCourseworkRelation;

var getPublicCourseworks = function getPublicCourseworks(authentication, queryParameters) {
  return common_1.get(authentication, courseworksPublicPath, queryParameters);
};

exports.getPublicCourseworks = getPublicCourseworks;

var getPublicCoursework = function getPublicCoursework(authentication, id) {
  return common_1.get(authentication, courseworksPublicPath + id);
};

exports.getPublicCoursework = getPublicCoursework;